import { NoteDetailPrintModel } from "./note-detail-print.model";

export class RequestNotePrintModel {
  branchId: number = 0;
  bussinessDocumentsDianTypeId: number = 0;
  bussinessDocumentsTypeId: number = 0;
  companyId: number = 0;
  costCenterId?: number;
  currencyId: number = 0;
  enterpriseId: number = 0;
  noteId: number = 0;
  noteTypeId: number = 0;
  addressBranch: string = '';
  branchCode: number = 0;
  branchName: string = '';
  BussinessDocumentsDianTypeIdInvoice: number = 0;
  clientNitName1: string = '';
  clientNitName2: string = '';
  consecutive: string = '';
  requestConsecutive: number = 0;
  constructionSiteAddress: string = '';
  costCenterCodeName: string = '';
  currencyCode: string = '';
  dateInvoice: Date = new Date();
  dateNote: Date = new Date();
  departmentCityBranch: string = '';
  discountValue: number = 0;
  enterpriseName: string = '';
  enterpriseNit: string = '';
  enterpriseSwSelfRetainer: boolean = false;
  enterpriseSwIcaSelfRetainer: boolean = false;
  isLevelArticle: boolean = false;
  ivaRate: number = 0;
  ivaValue: number = 0;
  noteText1: string = '';
  observationPrint: string | null = null;
  phoneBranch: string = '';
  prefixInvoice: string = '';
  reteFuenteValue: number = 0;
  reteIcaValue: number = 0;
  reteIvaValue: number = 0;
  subtotalValue: number = 0;
  titleNote: string = '';
  typeNote: string = '';
  totalValue: number = 0;
  totalValueInLetters: string = '';
  valueInvoice: number = 0;
  noteDetails: NoteDetailPrintModel[] = [];
}